<script lang="ts">
	import { isFilled, type Content } from '@prismicio/client';
	import { asText } from '@prismicio/client/richtext';
	import {
		PrismicImage,
		PrismicLink,
		PrismicRichText,
		type SliceComponentProps
	} from '@prismicio/svelte';
	import { inview } from 'svelte-inview';

	type Props = SliceComponentProps<Content.CallToActionSlice>;

	const { slice }: Props = $props();
</script>

<section
	class="call-to-action__{slice.variation}"
	data-slice-type={slice.slice_type}
	data-slice-variation={slice.variation}
	use:inview
	oninview_enter={(event) => {
		const { node } = event.detail;
		node.classList.add('show');
	}}
>
	{#if slice.variation == 'default'}
		<div class="call-to-action__{slice.variation}--image-container">
			{#if isFilled.image(slice.primary.image)}
				<PrismicImage
					field={slice.primary.image}
					class="call-to-action__{slice.variation}--image"
					loading={slice.primary.lazy_load_image === true ? 'lazy' : 'eager'}
				/>
			{/if}
		</div>

		<div class="call-to-action__{slice.variation}--content">
			<div class="container h-100">
				<div class="row h-100 align-items-end">
					<div class="col-12 col-lg-7 col-hd-6">
						{#if isFilled.richText(slice.primary.title)}
							<div class="call-to-action__{slice.variation}--title">
								<PrismicRichText field={slice.primary.title} />
							</div>
						{/if}

						{#if isFilled.richText(slice.primary.content)}
							<div class="call-to-action__{slice.variation}--text">
								<PrismicRichText field={slice.primary.content} />
							</div>
						{/if}

						{#if isFilled.link(slice.primary.link)}
							<PrismicLink
								field={slice.primary.link}
								class="call-to-action__{slice.variation}--link"
								title={asText(slice.primary.title)}
							/>
						{/if}
					</div>
				</div>
			</div>
		</div>
	{/if}
</section>
